import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { DatePipe, formatDate } from '@angular/common'
import { FormGroup, FormControl } from '@angular/forms';
import { SharingService } from 'src/app/services/sharing.service';
import { Pagamento } from 'src/app/models/pagamentos.mode';

@Component({
    selector: 'app-pagamentos',
    templateUrl: './pagamentos.component.html'
})
export class PagamentosComponent implements OnInit {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public gridData: Pagamento [] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService,private sharingService: SharingService,
        private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService, private datepipe: DatePipe) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);

        this.formGroup = new FormGroup({
            dataDe: new FormControl(),
            dataAte: new FormControl(),
        });
    }

    public load() {
        const hoje = new Date();
        const mesPassado = new Date(new Date().setMonth(new Date().getMonth() - 1));
    
        this.formGroup.controls['dataDe'].setValue(mesPassado);
        this.formGroup.controls['dataAte'].setValue(hoje);
    
        const inicioFormatado = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-ddTHH:mm:ss');
        const fimFormatado = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-ddTHH:mm:ss');
        const uri = `Pagamento/GetPagamentos?inicio=${inicioFormatado}&fim=${fimFormatado}`;

        this.api
            .getRequest<BaseHttpResponse<Pagamento[]>>(uri)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public loadPesquisa() {
        const dataDe = this.formGroup.get('dataDe')?.value;
        const dataAte = this.formGroup.get('dataAte')?.value;
    
        // Formatar datas para incluir horas e minutos (formato ISO 8601)
        const inicioFormatado = dataDe ? formatDate(dataDe, 'yyyy-MM-ddTHH:mm:00', 'en-US') : null;
        const fimFormatado = dataAte ? formatDate(dataAte, 'yyyy-MM-ddTHH:mm:59', 'en-US') : null;
        const uri = `Pagamento/GetPagamentos?inicio=${inicioFormatado}&fim=${fimFormatado}`;
    
        this.api
            .getRequest<BaseHttpResponse<Pagamento[]>>(uri)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch((err) => { });
    }

    public ngOnInit(): void {
        this.gridView = this.gridData;
        this.load();
    }

    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;

        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Pagamento) => {
        var data = this.datepipe.transform(args.dataRegistoServidor, 'yyyy-MM-dd HH:mm:ss')
        return `{data: ${data}, dataRegistoServidor: ${args.dataRegistoServidor},estado: ${args.estado}, descricaoEstado: ${args.descricaoEstado}, metodoPagamento: ${args.metodoPagamento}, descricaoMetodoPagamento: ${args.descricaoMetodoPagamento}, prePagamento: ${args.prePagamento}, montante: ${args.montante}, estadoFatura:${args.fatura.estado}, descricaoEstadoFatura: ${args.fatura.descricaoEstado}, faturaNumeroContribuinte: ${args.fatura.faturaNumeroContribuinte}, numeroContribuinte: ${args.fatura.numeroContribuinte}, iddoc: ${args.fatura.iddoc}, identificacaodocumento: ${args.fatura.identificacaodocumento}, identidade: ${args.fatura.identidade}, idpagamento: ${args.fatura.idpagamento}}`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId;
        const image: any = images;

        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;

        return image[code];
    }

    canList() {
        return User.canMovimentosList();
    }

    public allData(): ExcelExportData {
        console.log(this.gridView);  // Adicione este log para ver os dados que serão exportados
        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data.map((item: Pagamento) => {
                return {
                    ...item,
                    dataCriacao: this.datepipe.transform(item.dataCriacao, 'yyyy-MM-dd HH:mm:ss'),
                    dataAtualizacao: this.datepipe.transform(item.dataAtualizacao, 'yyyy-MM-dd HH:mm:ss'),
                    dataRegistoServidor: this.datepipe.transform(item.dataRegistoServidor, 'yyyy-MM-dd HH:mm:ss'),
                    faturaDataAtualizacao: this.datepipe.transform(item.fatura.dataAtualizacao, 'yyyy-MM-dd HH:mm:ss'),
                    faturaDataCriacao: this.datepipe.transform(item.fatura.dataCriacao, 'yyyy-MM-dd HH:mm:ss'),
                    faturaDataRegistoServidor: this.datepipe.transform(item.fatura.dataRegistoServidor, 'yyyy-MM-dd HH:mm:ss'),
                    
                };
            }),
        };
        console.log(result.data);  // Verifique o resultado após o processamento
        return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.gridView, filter);
    }

    public pesquisar(): void {
        const dataDe = this.formGroup.get('dataDe')?.value;
        const dataAte = this.formGroup.get('dataAte')?.value;
        if (dataDe == null || dataAte == null) {
            this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('preencherIntervaloDatas'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
            });
            
        } else {
            this.loadPesquisa();
        }
    }
}
